import React__default from 'react';
import { u as useCreateChannelContext } from '../../CreateChannelProvider-47a1c523.js';
import InviteUsers from './InviteUsers.js';
import SelectChannelType from './SelectChannelType.js';
import '../../sendbirdSelectors.js';
import '../../_rollupPluginBabelHelpers-05128ded.js';
import '../../topics-eb548880.js';
import '../../utils-e0c7329c.js';
import '../../useSendbirdStateContext.js';
import '../../withSendbird.js';
import '../../LocalizationContext-a82461b5.js';
import '../../stringSet-b60e9529.js';
import '../../index-6add7940.js';
import '../../ui/Modal.js';
import 'react-dom';
import '../../index-a9101009.js';
import '../../ui/Button.js';
import '../../index-6420013c.js';
import 'prop-types';
import '../../ui/Icon.js';
import '../../ui/IconButton.js';
import '../../MediaQueryContext-d6110905.js';
import '../../ui/UserListItem.js';
import '../../UserProfileContext-f3f446d2.js';
import '../../ui/Avatar.js';
import '../../ui/ImageRenderer.js';
import '../../uuid-717930b4.js';
import '../../ui/MutedAvatarOverlay.js';
import '../../ui/Checkbox.js';
import '../../ui/UserProfile.js';
import '../../ui/ContextMenu.js';
import '../../ui/SortByRow.js';
import '../../index-579ca9d7.js';
import '../../utils/message/getOutgoingMessageState.js';
var CreateChannel = function CreateChannel(props) {
  var _onCancel = props.onCancel,
    renderStepOne = props.renderStepOne;
  var _useCreateChannelCont = useCreateChannelContext(),
    step = _useCreateChannelCont.step,
    setStep = _useCreateChannelCont.setStep,
    userListQuery = _useCreateChannelCont.userListQuery;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, step === 0 && ((renderStepOne === null || renderStepOne === void 0 ? void 0 : renderStepOne()) || /*#__PURE__*/React__default.createElement(SelectChannelType, {
    onCancel: _onCancel
  })), step === 1 && /*#__PURE__*/React__default.createElement(InviteUsers, {
    userListQuery: userListQuery,
    onCancel: function onCancel() {
      setStep(0);
      _onCancel();
    }
  }));
};
export { CreateChannel as default };